//Settings.ts =================================================
import "./Util/Prototypes";

import * as CodedValueDomains from "./Util/CodedValueDomains";
import * as MainMap from "./MainMap";
import * as MainToolbar from "./Menus/MainToolbar";
import * as MapThemes from "./Widgets/MapThemes";
import * as Search from "./Search/Search";
import * as Settings from "./Settings";
import * as SignIn_Auth0 from "./Util/SignIn_Auth0";
import * as Util from "./Util/Util";

import { amber, cyan, blue, blueGrey, brown, deepOrange, grey, green, indigo, lightBlue, red, yellow } from '@mui/material/colors';
import { PaletteColorOptions, PaletteMode } from "@mui/material";

import SimpleMarkerSymbol from "@arcgis/core/symbols/SimpleMarkerSymbol";
import SimpleLineSymbol from "@arcgis/core/symbols/SimpleLineSymbol";
import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol";

import ReactDOM from "react-dom/client";

//To use the Server_Project (webapi) when debugging, both Visual Studio projects must be started at the same time and
//an application must be created in IIS for the published Server_Project. Right-click on the solution->properties to
//turn on Multiple startup projects and set both projects Action to Start.
export let webAPI_url: string = "https://www.greenwoodsc.gov/ReAssm_webapi/asp/webAPI";
export let webAPI_local_url: string = "https://localhost:44336/asp/webAPI";

//Auth0 keys.
export let auth0_domain: string = "greenwoodsc.auth0.com";
export let auth0_clientId: string = "Bm7x5zjVqwyZ6yrweQhtB4USNICbx50o";

export let getClientIpAddress: boolean = true;
export let signInEnabled: boolean = true;
export let showMapTips: boolean = true;
export let selectOnMapAlwaysActive: boolean = true; //If true, identifyEnabled must be false.
export let identifyEnabled: boolean = false;
export let verboseLogging: boolean = false;
export let showAlertMessages: boolean = false;
export let mercFactor: number = 1.2; //Mercator scale factor for printing. Increase to shrink measure line. Test with 690 foot measure line at 100 scale.

// Theme color settings.
// Pick theme colors here: https://material-ui.com/customization/color/ or https://en.wikipedia.org/wiki/Web_colors
export let primaryColor: string = "#607d8b"; // Must be hex. 607d8b-Grey, 26A69A-Light teal. Set to [500] color range.
export let secondaryColor: PaletteColorOptions = amber;   // Must be name - Amber, Green, etc.
export let colorType: PaletteMode = "light"; // light or dark.
export let headingColor: string = "#CFD8DC"; // 80CBC4 Table and Expansion panel heading background color.
export let leftPanelExpansionColor: string = "#eceff1"; // Search results left panel expansion panel background color.
export let leftPanelLabelColor: string = "#eceff1"; // Search results left panel label background color.

const multiColoredIcons: boolean = true;   // False means all icons will be grey.
const iconColor: string = "#607d8b";        // 607d8b-Grey, 26a69a-Teal. When not using multi-colored icons.
const toolBarIconColor: string = "#cfd8dc"; // cfd8dc-Grey, b2dfdb-Teal. When not using multi-colored icons.

export let backgroundColor: string = "#B0C4DE"; // Default: #fafafa, LightSteelBlue=#B0C4DE
export let paperColor: string = "#FFFFF0"; // Ivory = #FFFFF0, GhostWhite - Dropdown background too.

export let tabActiveColor: string = "rgba(255, 255, 255, 0.20)";
export let tabHoverColor: string = "rgba(255, 255, 255, 0.30)";
export let tabIndicatorColor: string = "Amber";

export let formControlHoverColor: string = "#CFD8DC"; // For check boxes, etc. B2DFDB

export let activeColor: string = "rgba(0, 0, 0, 0.54)"; // For drop down arrow color rgba(0, 0, 0, 0.54)
export let hoverColor: string = "#CFD8DC"; // For drop down Amber: #FFE57F, #FFD740
export let selectedColor: string = "#FFE57F"; // For drop down Gray: CFD8DC, #80CBC4

export let textColorPrimary: string = "rgba(38, 50, 56, 0.95)"; // rgba(38, 50, 56, 0.95) - Default: rgba(0, 0, 0, 0.87)
export let textColorSecondary: string = "rgba(183, 28, 28, 0.87)"; // Prompt text 183, 28, 28, 0.87 - Default: rgba(0, 0, 0, 0.54)

export let spinnerBackColor: string = "rgba(96, 125, 139, 0.70)";

export let breakpoint_sm: number = 800; // Default: 600
export let breakpoint_md: number = 1100; // Default: 960

export let borderRadius: number = 4; // Default: 4 - How rounded are the corners.

export let detailsFontSize: string = "0.95rem"; //Details text font size. 0.75
export let printDataTableFontSize: string = "0.75rem";

//Left panel width:
export let leftPanelWidth: number = 350;
export let smallScreenWidth: number = 500; //Left panel will show on bottom if width is less than this.
export let isPhone: boolean = false; //True means on a smart phone.

//Parcel outline colors for feature layers only.
export const darkBasemapWords: string[] = ["imagery", "dark", "County Basemap", "Ortho", "Aerial"];
export const forLightBasemap: number[] = [0, 0, 0, 1];
export const forDarkBasemap: number[] = [255, 215, 0]; //Gold: 255, 215, 0

//Highlight colors.
export let hoverPointSym = new SimpleMarkerSymbol({ color: [0, 255, 255, 0.7], size: 16 });
export let hoverLineSym = new SimpleLineSymbol({ color: [0, 255, 255, 0.7], width: 5 });
export let hoverPolygonSym = new SimpleFillSymbol({ color: [255, 255, 255, 0], style: "none", outline: { color: [0, 255, 255, 0.4], width: 1 } });

export let hoverPolygonSym3D = new SimpleFillSymbol({ color: [255, 255, 255, 0.2], style: "solid", outline: { color: [0, 255, 255, 0.7], width: 1 } });

export let selectedHoverPointSym = new SimpleMarkerSymbol({ color: [255, 215, 0, 0.7], size: 24 });
export let selectedhoverLineSym = new SimpleLineSymbol({ color: [255, 215, 0, 0.7], width: 12 });
export let selectedhoverPolygonSym = new SimpleFillSymbol({ color: [255, 215, 0, 0.01], style: "solid", outline: { color: [255, 215, 0, 0.7], width: 8 } });

export let identifyHighlightPointSym = new SimpleMarkerSymbol({ color: [255, 100, 19, 0.5], size: 14 });

export let identifyHighlightLineSym = new SimpleLineSymbol({ color: [255, 100, 19, 0.5], width: 5 });
export let identifyHighlightPolygonSym = new SimpleFillSymbol({ color: [0, 255, 255, 0.2], style: "solid", outline: { color: [230, 70, 0, 0.5], width: 4 } });

export let selectedHighlightPointSym = new SimpleMarkerSymbol({ color: [255, 16, 19, 0.5], size: 14 });
export let selectedHighlightLineSym = new SimpleLineSymbol({ color: [255, 16, 19, 0.5], width: 5 });
export let selectedHighlightPolygonSym = new SimpleFillSymbol({ color: [0, 255, 255, 0.3], style: "solid", outline: { color: [230, 0, 0, 0.5], width: 4 } });

export let testPolygonSym = new SimpleFillSymbol({ color: [0, 0, 0, 0.01], style: "solid", outline: { color: [0, 240, 240, 0.5], width: 4 } });
export let testPolygonSym2 = new SimpleFillSymbol({ color: [0, 0, 0, 0.01], style: "solid", outline: { color: [240, 0, 240, 0.5], width: 4 } });

//Ag use colors.
export let agUseHighlightPolygonSym = new SimpleFillSymbol({ color: [255, 255, 255, 0.01], style: "solid", outline: { color: [255, 120, 0, 1], width: 3 } });
export let agUseLineSym = new SimpleLineSymbol({ color: [0, 180, 255, 1], width: 2 });
export let agUsePolygonSym = new SimpleFillSymbol({ color: [255, 255, 255, 0.2], style: "solid", outline: { color: [0, 180, 255, 1], width: 2 } });

//Measure tool colors.
export let measureLineSym = new SimpleLineSymbol({ color: [0, 180, 255, 1], width: 2 });
export let measurePolygonSym = new SimpleFillSymbol({ color: [255, 255, 255, 0.2], style: "solid", outline: { color: [0, 180, 255, 1], width: 2 } });

//Tool names. Add a leading blank space to comment out.
export let mainToolbarTools: string[] = ["Quick Search", "Select on Map", "Map Layers", "Agricultural Use", "Sign_In_Out"];
export let mainToolbarToolsOmitOnPhone: string[] = ["Export Map", "Web Maps", "Dim_2D_3D", "Print"];

export let searchResultsTools: string[] = ["Zoom all", "Clear"];
export let searchResultsMoreTools: string[] = ["CSV"];

//Coded value domains for map image services.
export let codedValueSpecs: CodedValueDomains.iCodedValueSpec[] = [];
//codedValueSpecs.push({ layerName: "Map Layers", sublayerNames: ["Road Owners"] });
//codedValueSpecs.push({ layerName: "Sanitary Sewer", sublayerNames: ["Manhole", "Sewer Line"] });

// Map tips on feature layer hover.  Order by point layers first, then lines, then polygons.
export interface iMapTip {
   layerName: string;     // Feature layer name (case sensitive).
   fieldNames: string[];  // Comma separated field names array for the map tip.
   maxScale?: number;        // Don't show when zoomed in beyond. Default: 0
   minScale?: number;        // Don't show when zoomed out beyond. Default: 999999999
}

export let mapTipLayers: iMapTip[] = [
   { layerName: "Parcels", maxScale: 0, minScale: 9600, fieldNames: ["pin", "SiteAddress", "Bedrooms", "Bathrooms", "SqFt", "MarketValue_Land", "MarketValue_Improvement", "MarketValue_Total", "PictureLinks", "SketchLinks"] },
];

// Feature layer labeling interface.
export interface iLabelLayer {
   //For program use only.  Not settings.
   objectIDs?: number[];  // Used to keep track of existing labels.
   seqID?: object;        // Dictionary used to save sequential object id.
   prevSize?: object;     // Dictionary of previous length or area used to update label location.
   prevText?: object;     // Dictionary to save previous label text.
   prevNumStack?: object; // Dictionary to save previous number of stacked labels per feature.
   outFields?: string[];  // Field names to process.
   aboveAndBelow?: boolean; // True if labeling above and below a line.
   tinySize?: number;     // Used for showing or hiding labels based on feature size.
   labelClass?: any;      // Label class for labeling point feature classes (not polygons)
   maxScale?: number;     // Maximum scale of all scales for a layer.
   minScale?: number;     // Minimum scale of all scales for a layer.
   mapScaleChanged?: boolean;  //True if map scale has changed.
   activeFontSize?: number;    // Font size after adjusting for current map scale.
   pointGraphicMode?: boolean; //True means we are creating point graphics instead of labeling.
   geometryType?: string;      // Geom type of the feature layer.

   //Settings.
   layerName: string;      // Required - Layer name of the feature layer to label.
   fieldNames: string | string[]; // Required - Use comma separated field names for stacked multi-line labels.
   maxScales?: number | number[]; // Don't show when zoomed in beyond. Default: 0
   minScales?: number | number[]; // Don't show when zoomed out beyond. Default: 999999999
   color?: string | number[];     // Label color. Default: "black" [0, 0, 0, 1]
   haloColor?: string | number[]; // Halo color. Default: [255, 255, 255, 0.9]
   haloSize?: number;      // Halo size (points).  Default: 1.2
   font?: string;          // Font family: sans-serif, serif, cursive, monospace, fantasy, Avenir Next LT Pro Medium.  Default: "sans-serif"
   fontSize?: number;      // Font size (points).  Default: 9
   fontWeight?: string;    // normal or bold.  Default: "bold"
   renderAsGraphic?: boolean; // True means render the text as a graphic element.
   labelPosition?: any;    // above-center, above-left, above-right, below-center, below-left, below-right, center-center, center-left, center-right
   // Default: point: "above-right", line: above-center, polygon: center-center
   layerOnTop?: boolean;   // True means add the labels layer on top of all of the other layers. Default: false

   //Line and polygon specific labeling settings.
   sizeField?: string;         // Area or length field name for polygon and line feature classes. Default: "Shape__Area" or "Shape__Length"
   visibilityFieldNames?: string | string[]; // Enter comma separated field names used for processing custom line and polygon label visiblity.
   sizeTols?: number | number[]; // Size tolerances per minScale - Decrease to avoid label clutter for line and polygon labels.  Default: 50.
   labelsLayerName?: string;   // Name of the labels feature layer created by the website.  Default: "layerName Labels"
   showAll?: boolean;          // Show labels on clipped features near map extent edge. Default: true
   decimals?: number;          // Number of decimals to show for numeric fields. Default: n/a. Must be 0 or greater to be used.

   //Point graphics settings when not labeling.
   angleField?: string;    //The field in a point feature layer used to set the angle of a text graphic point. No default value.
   fontSizeField?: string; //The field in a point feature layer used to set the font size of a text graphic point. No default value.
}

// Feature layer labeling settings.
// Notes:
// Set the "labelsLayerName" if you want to label the same feature layer in two different ways.
// The "sizeField" is required for polygon and line feature classes.
// For stacked multi-line labels, make sure to set corresponding "minScales" to avoid clutter.
// If the "angleField" is present in the settings, then text graphics will be used instead of labeling.
// If the "fontSizeField" is present in the settings, then the value of the field will be used for the font size for text graphics only.
// The labeling results can be greatly customized in the Custom.ts file.
// Multiple scales on line features with stacked labels are not supported. Bug in ESRI API.
export let labelLayers: iLabelLayer[] = [
   { layerName: "Parcels", layerOnTop: true, fieldNames: ["pin", "TotalValue"], sizeField: "Area", color: "DarkBlue", minScales: [9600, 1200], haloColor: "LightYellow", fontSize: 8, renderAsGraphic: true },
   { layerName: "Soil Types", fieldNames: "slsCode", fontSize: 9, color: "SaddleBrown", minScales: 24000 },
];

//{ layerName: "Place Names", fieldNames: ["ShortName"], minScales: [4800], renderAsGraphic: true },
//{ layerName: "Address", fieldNames: ["HouseNum", "Street"], color: "DarkGreen", minScales: [2400, 600], fontSize: 8, renderAsGraphic: true },
//{ layerName: "Lot Numbers", fieldNames: "Label", color: "Crimson", minScales: 2400, fontSize: 8, labelPosition: "center-center", renderAsGraphic: true },
//{ layerName: "Road Names", fontSize: 9, fieldNames: ["FullName"], minScales: 20000, labelPosition: "center-center" },
//{ layerName: "Parcels", fieldNames: ["pin", "TotalValue"], sizeField: "Area", color: "DarkBlue", visibilityFieldNames: ["Owner"], minScales: [9600, 1200], haloColor: "LightYellow", fontSize: 8, renderAsGraphic: true },
//{ layerName: "Lot Dimensions", fieldNames: "Shape__Length", fontSize: 8, minScales: 9600, decimals: 1, renderAsGraphic: true },

//Agricultural use settings.
export let soilsLayerName: string = "Soil Types";
export let soilTypeFieldName: string = "SLSCODE";    //Case sensitive.
export let deedAcresFieldName: string = "DeedAcres"; //Case sensitive.

//React root elements referenced in multiple places.
export let dialogDivRoot: ReactDOM.Root = null;
export let printDivRoot: ReactDOM.Root = null;

//Icon settings.
export interface iToolInfo {
   tip: string;
   label: string;
   iconName: string;
   iconColor: string;
   iconColorToolbar: string;
}

//Choose icons: https://material.io/icons/ (use underscores when two words) Help: http://google.github.io/material-design-icons/
export function getToolInfo(toolName: string): iToolInfo {
   const ti: iToolInfo = { tip: "", label: toolName, iconName: "error", iconColor: null, iconColorToolbar: null };

   if (toolName === "Advanced Search") {
      ti.iconName = "filter_list";
      ti.tip = "Advanced Search";
      ti.iconColor = blue[700];
      ti.iconColorToolbar = cyan[300];

   } else if (toolName === "Basemap Gallery") {
      ti.iconName = "view_agenda";
      ti.tip = "Show basemap gallery";
      ti.iconColor = brown[300];
      ti.iconColorToolbar = brown[200];

   } else if (toolName === "Bookmarks") {
      ti.iconName = "bookmarks";
      ti.tip = "Show bookmarks";
      ti.iconColor = lightBlue[300];
      ti.iconColorToolbar = lightBlue[200];

   } else if (toolName === "Clear") {
      ti.label = "Clear";
      ti.iconName = "clear";
      ti.tip = "Clear selection";
      ti.iconColorToolbar = blueGrey[50];

   } else if (toolName === "Community Information") {
      ti.label = "Info";
      ti.iconName = "supervisor_account";
      ti.tip = "Community Information";
      ti.iconColor = green[600];
      ti.iconColorToolbar = green[200];

   } else if (toolName === "Compare Maps") {
      ti.iconName = "compare";
      ti.tip = "Compare maps with the swipe tool";
      ti.iconColor = deepOrange[600];
      ti.iconColorToolbar = deepOrange[200];

   } else if (toolName === "Contact Us") {
      ti.iconName = "contact_mail";
      ti.tip = "Contact us";
      ti.iconColor = blueGrey[500];

   } else if (toolName === "CSV") {
      ti.label = "Export to CSV (Comma Separated)";
      ti.iconName = "import_export";
      ti.iconColor = green[600];

   } else if (toolName === "Elevation Profile") {
      ti.iconName = "show_chart";
      ti.tip = "Create surface elevation profile/view Z values";
      ti.iconColor = green[600];
      ti.iconColorToolbar = green[200];

   } else if (toolName === "Export Map") {
      ti.iconName = "import_export";
      ti.tip = "Export visible map layers to multiple formats";
      ti.iconColor = green[600];
      ti.iconColorToolbar = green[200];

   } else if (toolName === "Heat Map") {
      ti.label = "Create heat map";
      ti.iconName = "fireplace";
      ti.tip = "Create heat map";
      ti.iconColor = deepOrange[400];
      ti.iconColorToolbar = deepOrange[400];

   } else if (toolName === "Legend") {
      ti.iconName = "list";
      ti.tip = "Show legend";
      ti.iconColor = deepOrange[700];
      ti.iconColorToolbar = deepOrange[300];

   } else if (toolName === "Mailing Labels") {
      ti.label = "Create Mailing Labels";
      ti.iconName = "mail_outline";
      ti.iconColor = red[400];

   } else if (toolName === "Map Layers") {
      ti.iconName = "layers";
      ti.tip = "Toggle map layer visibility";
      ti.iconColor = amber[600];
      ti.iconColorToolbar = amber[300];

   } else if (toolName === "Map Themes") {
      ti.iconName = "content_copy";
      ti.tip = "Choose map theme";
      ti.iconColor = deepOrange[500];
      ti.iconColorToolbar = deepOrange[200];

   } else if (toolName === "Measure") {
      ti.iconName = "format_line_spacing";
      ti.tip = "Measure distance and area";
      ti.iconColor = amber[900];
      ti.iconColorToolbar = amber[300];

   } else if (toolName === "Print") {
      ti.iconName = "print";
      ti.tip = "Print Map";
      ti.iconColor = blueGrey[500];
      ti.iconColorToolbar = blueGrey[50];

   } else if (toolName === "Quick Search") {
      ti.iconName = "search";
      ti.tip = "Quick Search";
      ti.label = "Search";
      ti.iconColor = lightBlue[800];
      ti.iconColorToolbar = lightBlue[200];

   } else if (toolName === "Region") {
      ti.label = "Region";
      ti.iconName = "near_me";
      ti.tip = "Select a neighborhood to filter search results by clicking on the map";
      ti.iconColorToolbar = blueGrey[50];

   } else if (toolName === "Comp Report") {
      ti.label = "Similar properties report";
      ti.iconName = "menu_book";
      ti.tip = "Create report of selected sales";
      ti.iconColor = blueGrey[500];
      ti.iconColorToolbar = blueGrey[50];

   } else if (toolName === "Sales Results") {
      ti.iconName = "event_available";
      ti.tip = "Sales results";
      ti.iconColor = blueGrey[500];
      ti.iconColorToolbar = grey[300];

   } else if (toolName === "Sales Search") {
      ti.iconName = "attach_money";
      ti.tip = "Search for property sales";
      ti.iconColor = green[600];
      ti.iconColorToolbar = green[200];

   } else if (toolName === "Search Results") {
      ti.iconName = "playlist_add_check";
      ti.tip = "Search and Select on Map results";
      ti.iconColor = blueGrey[500];
      ti.iconColorToolbar = grey[300];

   } else if (toolName === "Select on Map") {
      ti.label = "Select";
      ti.iconName = "near_me";
      ti.tip = "Select features on the map";
      ti.iconColor = lightBlue[400];
      ti.iconColorToolbar = lightBlue[300];

   } else if (toolName === "Share Map") {
      ti.iconName = "link";
      ti.tip = "Get a link to share the map";
      ti.iconColor = indigo.A200;

   } else if (toolName === "Sign_In_Out") {
      ti.label = "Sign in";
      ti.iconName = "lock_open";
      ti.tip = "Login to the website";
      ti.iconColor = blueGrey[600];
      ti.iconColorToolbar = grey[200];

      if (SignIn_Auth0.signedIn) {
         ti.label = "Sign out";
         ti.iconName = "lock";
         ti.tip = "Logout of the website";
      }

   } else if (toolName === "Sketch") {
      ti.iconName = "create";
      ti.tip = "Draw on the map";
      ti.iconColor = yellow[800];
      ti.iconColorToolbar = yellow[400];

   } else if (toolName === "Table View") {
      ti.label = "Table View";
      ti.iconName = "list_alt";
      ti.tip = "View in table format";
      ti.iconColor = blueGrey[500];
      ti.iconColorToolbar = blueGrey[50];

   } else if (toolName === "Toggle_MapTips") {
      ti.label = "Show hover map tips";
      ti.iconName = "chat";
      ti.tip = "Show hover map tips";
      ti.iconColor = amber[700];

      if (Settings.showMapTips) {
         ti.label = "Hide hover map tips";
         ti.tip = "Hide hover map tips";
      }

   } else if (toolName === "Toggle_XY") {
      ti.label = "Show coordinate display";
      ti.iconName = "format_list_numbered_rtl";
      ti.tip = "Show xy coordinate display";
      ti.iconColor = blueGrey[500];

      if (Settings.showCoordinates) {
         ti.label = "Hide coordinate display";
         ti.tip = "Hide xy coordinate display";
      }

   } else if (toolName === "Web Maps") {
      ti.iconName = "person";
      ti.tip = "Google Maps/Street View and Bing Maps/Streetside";
      ti.iconColor = amber[700];
      ti.iconColorToolbar = amber[200];

   } else if (toolName === "Zoom all") {
      ti.iconName = "zoom_in";
      ti.tip = "Zoom to all records";

      //=== Other tools. ================
   } else if (toolName === "Dim_2D_3D") {
      ti.label = "2D";
      ti.iconName = "map";
      ti.tip = "View map in 2D";
      ti.iconColor = cyan[700];
      ti.iconColorToolbar = cyan[300];

      if (MainMap.view2D) {
         ti.label = "3D";
         ti.iconName = "terrain";
         ti.tip = "View map in 3D";
         ti.iconColor = cyan[700];
         ti.iconColorToolbar = cyan[300];
      }

      //Sketch and measure tools.
   } else if (toolName === "Polyline") {
      ti.label = "Dist";
      ti.iconName = "timeline";
      ti.tip = "Measure distance by drawing a line on the map";
      ti.iconColorToolbar = blueGrey[50];

   } else if (toolName === "Polygon") {
      ti.label = "Area";
      ti.iconName = "turned_in_not";
      ti.tip = "Measure area by drawing a polygon on the map";
      ti.iconColorToolbar = blueGrey[50];

   } else if (toolName === "Rectangle") {
      ti.label = "Rect";
      ti.iconName = "check_box_outline_blank";
      ti.tip = "Draw a rectangle and calculate the area";
      ti.iconColorToolbar = blueGrey[50];

   } else if (toolName === "Circle") {
      ti.label = "Circle";
      ti.iconName = "radio_button_unchecked";
      ti.tip = "Draw a circle and calculate the radius and area";
      ti.iconColorToolbar = blueGrey[50];

   } else if (toolName === "Edit Measurement") {
      ti.label = "Edit";
      ti.iconName = "format_shapes";
      ti.tip = "Select a measurement for editing";
      ti.iconColorToolbar = blueGrey[50];

   } else if (toolName === "Done") {
      ti.label = "Done";
      ti.iconName = "done";
      ti.tip = "Complete the current drawing";
      ti.iconColorToolbar = blueGrey[50];

   } else if (toolName === "Undo") {
      ti.label = "Undo";
      ti.iconName = "undo";
      ti.tip = "Undo the last edit";
      ti.iconColorToolbar = blueGrey[50];

   } else if (toolName === "Redo") {
      ti.label = "Redo";
      ti.iconName = "redo";
      ti.tip = "Redo the last edit";
      ti.iconColorToolbar = blueGrey[50];

      //Agricultural use tools.
   } else if (toolName === "Agricultural Use") {
      //ti.label = "Ag Use";
      ti.iconName = "agriculture";
      ti.tip = "Agricultural Use";
      ti.iconColor = green[600];
      ti.iconColorToolbar = green[200];

   } else if (toolName === "Timber") {
      ti.label = toolName;
      ti.iconName = "fence";
      ti.tip = "Draw a polygon on the map";
      ti.iconColorToolbar = blueGrey[50];

   } else if (toolName === "Crop") {
      ti.label = toolName;
      ti.iconName = "grass";
      ti.tip = "Draw a polygon on the map";
      ti.iconColorToolbar = blueGrey[50];

      //IBM tools.
   } else if (toolName === "Adjust Many") {
      ti.iconName = "edit";
      ti.tip = "Adjust many values";

   } else if (toolName === "Set to CAMA") {
      ti.iconName = "edit";
      ti.tip = "Set to CAMA";

   } else if (toolName === "Edit") {
      ti.iconName = "edit";
      ti.tip = "Edit market values";

   } else if (toolName === "Mobile Homes") {
      ti.iconName = "view_agenda";
      ti.tip = "Edit mobile home values";
   }

   //Disable multi-colored icons.
   if (!multiColoredIcons) {
      ti.iconColor = null;
      ti.iconColorToolbar = null;

      ti.iconColor = iconColor;
      ti.iconColorToolbar = toolBarIconColor;
   }
   return ti;
}

//Define settings interfaces.
export interface iLayer {
   layerName: string;
   layerAccessLevel: number;
   layerIndex: number;
   mapServiceID: string;
   mapServiceURL: string;
   geometryType: string;

   simpleSearchFields: string[];
   simpleSearchAliases: string[];
   simpleSearchIsInteger: boolean[];
   simpleSearchAccessLevels: number[];

   selectFrom: boolean;
   identifyFrom: boolean;
   id_FieldName: string;
   id_FieldIsInteger: boolean;

   headingFields: string[];
   displayFields: string[];
   omitAdvancedSearchFields: string[];
   thematicAliases: string[];
   doNotExport: string[];
   oneToMany: string[];
   sortBy: string;
}

export interface iIdentifyLayerMI {
   mapServiceID: string;
   mapServiceURL: string;
   mapService_accessLevel: number;
   layerName: string[];
   layerIndex: number[];
}

export interface iMapTheme {
   name: string;
   details: iMapThemesDetail[];
   accessLevel: number;
}

export interface iMapThemesDetail {
   mapServiceID: string;
   opacity: number;
   sublayers: iSublayer[];
}

export interface iSublayer {
   name: string;
   opacity: number;
}

export interface iCompareTheme {
   name: string;
   layers: iCompareDetail[];
}

export interface iCompareDetail {
   layerType: string;  //Layers or Basemap
   layerNames: string[];
}

export interface iLegendLayer {
   mapServiceID: string;
   sublayerNames: string[];
}

export interface iCommunityInfo {
   heading: string;
   description: string;
   layerName: string;
   fieldNames: string[];
   aliasNames: string[];
   hyperLinkFields: string[];
   searchMode: string;
   radius: number;
   maxResults: number;
   hideMeasurement: boolean;
}

export interface iBookmark {
   heading: string;
   names: string[];
   mbrs: string[];
   thumbs: string[];
}

export interface iScaleDependentLines {
   layerName: string;
   scales: number[];
   pointSizes: number[];
}

export interface iMailingLabels {
   layerName: string;
   nameFields: string[];
   addressFields: string[];
   cityStateZipFields: string[];
}

export interface iGeocode {
   enabled: boolean;
   overallPlaceholder: string;
   address: iGeocodeSource;
   street: iGeocodeSource;
}

export interface iGeocodeSource {
   title: string;
   placeholder: string;
   url: string;
   singleLineFieldName: string;
}

export interface iSecurity {
   accessLevel: number;
   accessLevel_bigPrint: number;
   accessLevel_mailingLabels: number;
   accessLevel_exportMapLayers: number;
   accessLevel_surfaceProfile: number;
   accessLevel_simpleSearch: number;
}

export interface iPrint {
   title: string;
   scales: string[];
   paperSizes: string[];
   bigPrintMinWidth: number;
   dpi: number;
   margin: number;
   logo: string;
   disclaimer: string;
}

export interface iPopUpTable {
   title: string;
   heading: string;
   tableURL: string;
   orderBy: string;
   whereStr: string;
}

export interface iLayerList {
   layerName: string;
   showOpacity: boolean;
   showLegend: boolean;
   openLegend: boolean;
   showInfo: boolean;
}

export interface iMapService {
   id: string;
   mapServiceURL: string;
   mapServiceName: string;
   serviceType: string;
   thumbnail: string;
   opacity: number;
   imageFormat: string;
   title: string;
   isGlobal: boolean;
   accessLevel: number;
}

export interface iCodeName {
   code: number | string;
   name: string;
}
export interface iCodedValue {
   layerName: string;
   fieldName: string;
   values: iCodeName[];
}

export let websiteTitle: string;
export let webServerURL: string;
export let webSitePath: string;
export let webSiteLogo: string;
export let startupTool: string;

export let homeServices_URL: string;
export let printService_URL: string;
export let exportMapGPServer_URL: string;
export let queryLayers_URL: string;

export let arcGisOutput_folder: string;
export let enabled3D: boolean;
export let accessLevel3D: number;
export let splashScreenHideLevel: number;

export let doubleBasemapTileLevels: boolean;
export let showBasemapToggle: boolean;
export let showCoordinates: boolean;
export let useArcGisThumbnails: boolean;

export let overviewMapID: string;
export let basemapToggleLayerName: string;

export let activeMapTheme: string;
export let activeLayer: string;

export let portalUrl: string;
export let proxyUrl: string;
export let proxyMapServiceURLs: string[];
export let corsEnabledServers: string[];

export let basemaps: iMapService[];
export let operMaps: iMapService[];
export let elevMaps: iMapService[];
export let layerIDsFor3D: string[];
export let sketchSnappingLayers: string[];

export let mapExtentStart: string;
export let mapExtentFull: string;
export let wkID: number;

export let mapThemes: iMapTheme[];
export let startupLeftTheme: string;
export let startupRightTheme: string;
export let compareThemes: iCompareTheme[];
export let mailLabel: iMailingLabels;
export let geocode: iGeocode;
export let legendLayers: iLegendLayer[];
export let communityInfo: iCommunityInfo[];
export let bookmarks: iBookmark[];
export let scaleDependentLines: iScaleDependentLines[];
export let security: iSecurity;
export let print: iPrint;
export let identifyLayersMI: iIdentifyLayerMI[];
export let popupTables: iPopUpTable[];
export let layerLists: iLayerList[];
export let codedValues: iCodedValue[];

export let layers: iLayer[];
export let securedLayers: string[];
export let selectableLayers: string[];
export let identifyLayers: string[];

export let parcelLayerName: string;
export let streetCenterlinesLayerName: string;
export let pin_fieldName: string;
export let propertyAddress_fieldName: string;
export let insertDashesOnPIN: boolean;

export let autoCompleteURL: string;
export let accessLevel_SimpleSearch: number;
export let autoCompleteURL_Secure: string;

export let maxRecordCount: number;
export let maxAddRecordCount: number;
export let maxSearchRecPerPage: number;
export let maxAllowableOffset: number;
export let mercatorDistanceFudgeFactor: number;
export let parcelInsideBufferDistance: number;

export let zoomToMarginPercent: number;
export let zoomToPointMarginDistance: number;

export let maxExportPublic: number;
export let maxExportSecured: number;

//Setters.
export function setEnabled3D(enable_3D: boolean) {
   enabled3D = enable_3D;
}
export function setShowMapTips(showTips: boolean) {
   showMapTips = showTips;
}
export function setShowCoordinates(showCoords: boolean) {
   showCoordinates = showCoords;
}
export function setPrintDivRoot(divRoot: ReactDOM.Root) {
   printDivRoot = divRoot;
}
export function setDialogDivRoot(divRoot: ReactDOM.Root) {
   dialogDivRoot = divRoot;
}
export function setIsPhone(phone: boolean) {
   isPhone = phone;
}
export function setLeftPanelWidth(width: number) {
   leftPanelWidth = width;
}

//Initialize settings with xml file server settings.
export function setClientSettings(s: any): void {
   Util.logMsg("Assigning client settings from server.");

   websiteTitle = s.websiteTitle as string;
   webServerURL = s.webServerURL as string;
   webSitePath = s.webSitePath as string;
   webSiteLogo = s.webSiteLogo as string;
   startupTool = s.startupTool as string;

   homeServices_URL = s.homeServices_URL as string;
   printService_URL = s.printService_URL as string;
   exportMapGPServer_URL = s.exportMapGPServer_URL as string;
   queryLayers_URL = s.queryLayers_URL as string;

   arcGisOutput_folder = s.arcGisOutput_folder as string;
   accessLevel3D = s.accessLevel3D as number;
   splashScreenHideLevel = s.splashScreenHideLevel as number;

   doubleBasemapTileLevels = s.doubleBasemapTileLevels as boolean;
   showBasemapToggle = s.showBasemapToggle as boolean;
   showCoordinates = s.showCoordinates as boolean;
   useArcGisThumbnails = s.useArcGisThumbnails as boolean;

   overviewMapID = s.overviewMapID as string;
   basemapToggleLayerName = s.basemapToggleLayerName as string;

   activeMapTheme = s.activeMapTheme as string;
   activeLayer = s.activeLayer as string;

   portalUrl = s.portalUrl as string;
   proxyUrl = s.proxyUrl as string;

   proxyMapServiceURLs = s.proxyMapServiceURLs as string[];
   corsEnabledServers = s.corsEnabledServers as string[];

   basemaps = s.basemaps as iMapService[];
   operMaps = s.operMaps as iMapService[];
   elevMaps = s.elevMaps as iMapService[];
   layerIDsFor3D = s.layerIDsFor3D as string[];
   sketchSnappingLayers = s.sketchSnappingLayers as string[];

   mapExtentStart = s.mapExtentStart as string;
   mapExtentFull = s.mapExtentFull as string;
   wkID = s.wkID as number;

   mapThemes = s.mapThemes as iMapTheme[];
   startupLeftTheme = s.startupLeftTheme as string;
   startupRightTheme = s.startupRightTheme as string;
   compareThemes = s.compareThemes as iCompareTheme[];
   mailLabel = s.mailLabel as iMailingLabels;
   geocode = s.geocode as iGeocode;
   legendLayers = s.legendLayers as iLegendLayer[];
   communityInfo = s.communityInfo as iCommunityInfo[];
   bookmarks = s.bookmarks as iBookmark[];
   scaleDependentLines = s.scaleDependentLines as iScaleDependentLines[];
   security = s.security as iSecurity;
   print = s.print as iPrint;
   identifyLayersMI = s.identifyLayersMI as iIdentifyLayerMI[];
   popupTables = s.popupTables as iPopUpTable[];
   layerLists = s.layerLists as iLayerList[];

   layers = s.layers as iLayer[];
   securedLayers = s.securedLayers as string[];
   selectableLayers = s.selectableLayers as string[];
   identifyLayers = s.identifyLayers as string[];

   parcelLayerName = s.parcelLayerName as string;
   streetCenterlinesLayerName = s.streetCenterlinesLayerName as string;
   pin_fieldName = s.pin_fieldName as string;
   propertyAddress_fieldName = s.propertyAddress_fieldName as string;
   insertDashesOnPIN = s.insertDashesOnPIN as boolean;

   autoCompleteURL = s.autoCompleteURL as string;
   accessLevel_SimpleSearch = s.accessLevel_SimpleSearch as number;
   autoCompleteURL_Secure = s.autoCompleteURL_Secure as string;

   maxRecordCount = s.maxRecordCount as number;
   maxAddRecordCount = s.maxAddRecordCount as number;
   maxSearchRecPerPage = s.maxSearchRecPerPage as number;
   maxAllowableOffset = s.maxAllowableOffset as number;
   mercatorDistanceFudgeFactor = s.mercatorDistanceFudgeFactor as number;
   parcelInsideBufferDistance = s.parcelInsideBufferDistance as number;

   zoomToMarginPercent = s.zoomToMarginPercent as number;
   zoomToPointMarginDistance = s.zoomToPointMarginDistance as number;

   maxExportPublic = s.maxExportPublic as number;
   maxExportSecured = s.maxExportSecured as number;

   //Init module level variables from server settings.
   MapThemes.setActiveMapThemeName(activeMapTheme);
   Search.setActiveLayerName(activeLayer);
   codedValues = []; //Initialize coded values array.

   //Disable buttons.
   MainToolbar.addOrRemove3D(); //Add or remove 3D button.

   if (!signInEnabled) {
      mainToolbarTools.Remove("Sign_In_Out");
   }

   Util.logMsg("Done assigning settings from server.");
}
